import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getUserCountry = () => {
  return localStorage.getItem('userCountry');
};

/**
 * Whether a real discount exists, i.e. the discounted price is set and is
 * actually lower than the public price. Guards against missing/zero discount
 * fields that used to render a struck-through price with no discount.
 */
export const hasDiscount = (
  actualPrice?: number | string | null,
  discountPrice?: number | string | null
): boolean => {
  const actual = Number(actualPrice);
  const discounted = Number(discountPrice);
  if (
    actualPrice === null ||
    actualPrice === undefined ||
    actualPrice === "" ||
    discountPrice === null ||
    discountPrice === undefined ||
    discountPrice === "" ||
    Number.isNaN(actual) ||
    Number.isNaN(discounted)
  ) {
    return false;
  }
  return discounted > 0 && discounted < actual;
};

/**
 * Formats a subscription end date in milliseconds into a human-readable string
 * @param subscriptionEndsAt - The subscription end date in milliseconds
 * @returns A formatted string like "Expires in 15 months 5 days" or "Expired" or "No expiration"
 */
export const formatSubscriptionExpiry = (subscriptionEndsAt: number | undefined): string => {
  if (!subscriptionEndsAt || subscriptionEndsAt <= 0) {
    return "No expiration";
  }

  // Convert milliseconds to seconds and calculate time remaining
  const endTimeInSeconds = Math.floor(subscriptionEndsAt / 1000);
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  let totalSeconds = endTimeInSeconds - currentTimeInSeconds;

  // If subscription has already expired
  if (totalSeconds <= 0) {
    return "Expired";
  }

  const months = Math.floor(totalSeconds / (30 * 24 * 60 * 60));
  totalSeconds %= 30 * 24 * 60 * 60;
  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  totalSeconds %= 24 * 60 * 60;
  const hours = Math.floor(totalSeconds / (60 * 60));

  let result = "Expires in ";
  if (months > 0) result += `${months} month${months > 1 ? "s" : ""} `;
  if (days > 0) result += `${days} day${days > 1 ? "s" : ""} `;
  if (hours > 0) result += `${hours} hour${hours > 1 ? "s" : ""}`;
  
  if (months === 0 && days === 0 && hours === 0) {
    result = "Expires soon";
  }

  return result.trim();
};
